import { ROLES_PREMISSAS_VISUALIZACAO } from "./departamentosOrcamento";

// Premissas · Rateio entre Empresas: o painel do rateio (% GT/CIGTA/CRIA por categoria) e do
// saldo inicial de prejuízo fiscal — mudou de tela (2026-09-16: saiu de dentro de "DRE por
// Empresa" para uma visão própria no grupo "Premissas"). Igual às demais telas de Premissas:
// leitura ampla (todos os diretores/roles de departamento); edição só admin (ver isAdmin em
// pages/GestaoOrcamentaria/premissasRateio.js) — "DRE por Empresa" continua restrito a
// ROLES_DRE_EMPRESA, só o painel de rateio abriu.
// Espelha backend/config.py ROLES_PREMISSAS_RATEIO — mantenha os dois em sincronia.
export const ROLES_PREMISSAS_RATEIO = ROLES_PREMISSAS_VISUALIZACAO;
